module.exports = __webpack_public_path__ + "static/song-c510fdd7960204c6a1bc7050b0dab214.mp3";